import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/SearchMetrics.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/reports/v1/queries`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`, t));
	}
	getProducts(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/products`, t));
	}
	getProduct(e, t, r) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/products/${t}`, r));
	}
};
export { n as SearchMetrics };

//# sourceMappingURL=SearchMetrics.js.map